<template>
<div class="work" id="work-8">
	<h2><span>04</span> Toolbelt</h2>
	<div class="subtitle">
		<h3><span>Year</span>2021</h3>
		<h3><span>Product</span>iPad App</h3>
		<h3><span>Technology</span>React / Figma</h3>
	</div>
	<blockquote>
		The Toolbelt App is an internal tool for Invitation Homes associates to inspect their properties and ensure the quality of their rental homes.
	</blockquote>
	<figure class="int">
		<figcaption>
			<h3>Objective for this project</h3>
			<p>Design an iPad app for Invitation Homes workers in the field to inspect and annotate a home's condition and maintenance needs.</p>
			<h3>My Role</h3>
			<p>Understand the user journey and the inspection process to provide the best and faster experience possible in the iPad app.</p>
		</figcaption>
		<span><img src="../../assets/toolbelt-01.jpg" alt="App login"></span>
		<span><img src="../../assets/toolbelt-02.jpg" alt="App page"></span>
	</figure>
	<figure class="half">
		<figcaption>
			<h3>The Solution</h3>
			<p>With a large team of five developers and three designers, me included, working to solve users' pain points and replace the previous app, Toolbelt's solution can be summarized as a complex app that's easy to use.</p>
			<p>As a significant result, optimizing the time spent in the app and increasing the accuracy of the collected information contributed to better decisions and outcomes.</p>
		</figcaption>
		<img src="../../assets/toolbelt-05.jpg" alt="Toobelt process flow">
		<img src="../../assets/toolbelt-06.jpg" alt="Toobelt process flow">
	</figure>
	<figure class="half">
		<figcaption>
			<blockquote>It was a long journey to the MVP of the app, but also a valuable learning experience in terms of complexity and exclusive solutions.</blockquote> 
		</figcaption>
		
	</figure>
	<figure class="half">
		<span><img src="../../assets/toolbelt-04.jpg" alt="Toolbelt App 3"></span>
		<span><img src="../../assets/toolbelt-03.jpg" alt="Toolbelt App 4"></span>
	</figure>
	<blockquote>
		"This is an awarded app, recognized by the real state industry and technology organizations, which follows up to keep the good work of this dedicated team. The app is not public, but the company can be accessed in <a href="//invitationhomes.com" target="_blank">invitationhomes.com</a>"
	</blockquote>
</div>
</template>